export class Disclaimer {

  constructor(title: string, paragraphs: string[]) {
    this.title = title;
    this.paragraphs = paragraphs;
  }

  title: string;
  paragraphs: string[];
}
